<template>
  <div class="custom-control custom-checkbox ml-2 my-4">
    <input type="checkbox" class="custom-control-input" :id="elementId" :checked="value" @change="updateValue" />
     <!--<mdb-input type="checkbox" :id="elementId" :checked="value" :label="label" :disabled="disabled" @change="updateValue" ref="inputField" />-->
    <label class="custom-control-label" :for="elementId">{{ label }}</label>

    <div class="invalid-feedback" v-if="hasErrors" v-html="errorMessage"></div>
  </div>
</template>

<script>
import { mdbInput } from 'mdbvue'

export default {
  components: {
    mdbInput
  },

  props: {
    value: {
      type: Boolean,
      required: true
    },

    label: {
      type: String
    },

    disabled: {
      type: Boolean,
      default: false
    },

    errors: {
      default: null
    }
  },

  computed: {
    hasErrors () {
      return this.errors !== null && this.errors.length > 0
    },

    errorMessage () {
      return this.errors.join('<br>')
    },

    elementId () {
      return `checkbox_${this._uid}`
    }
  },

  methods: {
    updateValue (event) {
      this.$emit('input', event.target.checked)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/formFields/eCheckbox.vue